import { getSupabaseClient } from './supabase.client.js';

/**
 * Lee las reglas de orden por categoría desde Supabase (anon client, lectura pública).
 * Devuelve un mapa { [fudo_category_id]: 'none'|'takeaway'|'both' }.
 * Si Supabase no está configurado devuelve {} — categorías sin regla equivalen a 'both'.
 *
 * @returns {Promise<Record<string, 'none'|'takeaway'|'both'>>}
 * @throws {Error} si Supabase responde con error
 */
export async function fetchCategoryRules() {
    const client = getSupabaseClient();
    if (!client) return {};

    const { data, error } = await client
        .from('category_order_rules')
        .select('fudo_category_id, estado');

    if (error) throw new Error(error.message);

    return (data ?? []).reduce((map, row) => {
        map[row.fudo_category_id] = row.estado;
        return map;
    }, {});
}

/**
 * Escribe (upsert) una regla de orden para una categoría.
 * Requiere sesión de admin (RLS is_admin() permite la escritura).
 *
 * @param {{ fudo_category_id: string, estado: 'none'|'takeaway'|'both', nombre: string }} rule
 * @returns {Promise<void>}
 * @throws {Error} si Supabase responde con error
 */
export async function upsertCategoryRule({ fudo_category_id, estado, nombre }) {
    const client = getSupabaseClient();
    if (!client) throw new Error('Supabase no está configurado.');

    const { error } = await client
        .from('category_order_rules')
        .upsert({
            fudo_category_id,
            estado,
            nombre,
            updated_at: new Date().toISOString(),
        }, { onConflict: 'fudo_category_id' });

    if (error) throw new Error(error.message);
}
